import { useGetQuery as useGetSeatAssignments } from 'app-users-service-client/v1/seat-assignments/self';
import { SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE, SUPER_ADMIN_SCOPE } from '../../constants/ScopesConstants';
import { useHasScope } from './authHooks';
const SERVICE_SEATS = ['service-professional', 'service-enterprise', 'service-professional-trial', 'service-enterprise-trial'];
export function useIsMissingServiceSeat() {
  const {
    response: seatAssignments
  } = useGetSeatAssignments();
  const {
    hasScope: isSuperAdmin
  } = useHasScope(SUPER_ADMIN_SCOPE);
  const {
    hasScope: hasArticleEditScope
  } = useHasScope(SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE);
  if (isSuperAdmin) {
    return false;
  }
  return !!(hasArticleEditScope && seatAssignments && !seatAssignments.some(seat => SERVICE_SEATS.includes(seat.seatName)));
}